import Api from '@/services/Index';

const getInternshipStudent = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/internship/application/student-form',);
}
const internshipApplication = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return Api.post('/internship/application/make-application',formData,config);
}
const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/internship/applications', config);
}
const show = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/internship/applications/' + id);
}
const get = async (code) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/internship/applications/' + code);
}
const downloadAsExcel = (config)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/internship/applications/excel-export',{...config,responseType:'arraybuffer'})
}
const update = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/approval/step/update/status/' + id, formData);
}

export default {
    getInternshipStudent,
    internshipApplication,
    getAll,
    show,
    get,
    update,
    downloadAsExcel
}
